<form [formGroup]="apiConnectionProfileForm">
  <div id="pnProfiles" class="pnProfiles commonFormsCss" style="display: block">
    <div class="pnclose">
      <a href="#" (click)="closePannel()"><i class="fa fa-chevron-circle-left fa1x"></i></a>
    </div>
    <div class="row pd-10">
      <div class="col-sm-5">
        <h3>API Connection Profile</h3>
        <div class="input-group">
          <select id="sndProfile" class="form-control form-select" formControlName="apiConnectionProfileName" (change)="setProfile($event, true)">
            <option *ngFor="let connectionName of connectionNames" [value]="connectionName">{{ connectionName }}</option>
          </select>
          <div class="input-group-btn">
            <button type="button" (click)="getProfile()" class="btn btn-mnu btn-addon pd-6">
              <i class="fa fa-edit"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-1"></div>
      <div class="col-sm-5">
        <h3>Import/Export Profile</h3>
        <input type="radio" #importProfileElement name="profile" id="importProfile" (click)="importProfiles()" /><label class="ms-1 me-3" for="importProfile">Import</label>
        <input type="radio" #exportProfileElement name="profile" id="exportProfile" (click)="exportProfiles()" /><label class="ms-1 me-3" for="exportProfile">Export</label><br />
        <input type="file" #inputFileElement id="file" *ngIf="showHideChooseFile" (change)="upload($event)" />
        <ng-container *ngIf="uploadSuccess"> Upload Successful </ng-container>
      </div>
    </div>
    <input type="hidden" id="pfId" name="pfId" data-bind="Id" />

    <div class="profileNote">
      <h3>Note:</h3>
      <p>
        We have had to make a change to this tool and this unfortunately has affected your saved profiles. <br />Please recreate your profile/s using the ADD NEW CONNECTION option to continue using
        this tool.
      </p>
    </div>

    <div id="pfEditpn" *ngIf="showAddNewConnection">
      <div class="row pl-10 mt-50">
        <div class="col-sm-12">
          <h3>Add/Update a Connection</h3>
        </div>
      </div>
      <div class="row pd-10">
        <div class="col-md-5">
          <div class="form-group">
            <span class="sml">Connection Name</span><br />
            <input type="text" formControlName="connectionName" class="form-control" maxlength="30" [ngClass]="{ 'is-invalid': submitted && formControls['connectionName'].errors }" />
            <div class="field-validation-valid text-danger"></div>
          </div>
          <div class="form-group">
            <span class="sml">API URI</span><br />
            <select id="uri-list" formControlName="apiURI" class="form-control" [ngClass]="{ 'is-invalid': submitted && formControls['apiURI'].errors }">
              <option *ngFor="let apiURI of apiURIs" [value]="apiURI">
                {{ apiURI }}
              </option>
            </select>
          </div>
          <div *ngIf="isApiURICustom()" class="form-group">
            <span class="sml">Custom Endpoint</span><br />
            <input
              id="taName"
              name="taName"
              type="text"
              class="form-control"
              maxlength="30"
              formControlName="apiURICustom"
              placeholder="e2e"
              [ngClass]="{ 'is-invalid': submitted && formControls['apiURICustom'].errors }"
            />
          </div>
          <div class="form-group">
            <span class="sml">Client Key</span><br />
            <div class="posRelative">
              <input
                name="password"
                formControlName="clientKey"
                maxlength="50"
                [type]="showPassword ? 'text' : 'password'"
                class="form-control pwd-control"
                id="password-field"
                [ngClass]="{ 'is-invalid': submitted && formControls['clientKey'].errors }"
              />

              <i alt="show" class="far fa-eye eyeIcon eye-show" (click)="showPassword = !showPassword" [class.hide]="!showPassword"></i>
              <i alt="hide" class="far fa-eye-slash eyeIcon eye-hide" (click)="showPassword = !showPassword" [class.hide]="showPassword"></i>
            </div>
          </div>
          <div class="form-group">
            <span class="sml">AgencyName</span><br />
            <input
              id="taName"
              name="taName"
              type="text"
              class="form-control"
              formControlName="agencyName"
              maxlength="30"
              [ngClass]="{ 'is-invalid': submitted && formControls['agencyName'].errors }"
            />
          </div>
          <div class="form-group">
            <span class="sml">IATA #</span><br />
            <input id="iata" name="iata" type="text" class="form-control" formControlName="iata" maxlength="30" [ngClass]="{ 'is-invalid': submitted && formControls['iata'].errors }" />
          </div>
          <div class="form-group">
            <span class="sml">Contact eMail</span><br />
            <input
              id="taEmail"
              name="taEmail"
              type="text"
              class="form-control"
              formControlName="contactEMail"
              maxlength="30"
              [ngClass]="{ 'is-invalid': submitted && formControls['contactEMail'].errors }"
            />
          </div>
        </div>

        <div class="col-md-1"></div>
        <div class="col-md-6">
          <h4>Corporate Sender</h4>
          <input formControlName="corporateSender" (click)="isCorporateSender()" class="me-2" type="checkbox" />
          <span>Corporate Sender</span><br />
          <input formControlName="directCorporate" (click)="isDirectCorporate()" class="me-2" type="checkbox" />
          <span>Direct Corporate</span><br />

          <div class="form-group">
            <span class="sml">Corporate ID</span><br />
            <input formControlName="corporateID" type="text" class="form-control" maxlength="30" [ngClass]="{ 'is-invalid': submitted && formControls['corporateID'].errors }" />
          </div>

          <h4>TMC Details</h4>

          <div class="form-group">
            <input formControlName="includeAggregator" type="checkbox" checked="" />
            Include Aggregator <br />
          </div>
          <div class="form-group mt-3">
            <span class="sml">AggregatorID</span><br />
            <input type="text" class="form-control" formControlName="aggregatorID" maxlength="30" [ngClass]="{ 'is-invalid': submitted && formControls['aggregatorID'].errors }" />
          </div>
          <div class="form-group">
            <span class="sml">AggregatorName</span><br />
            <input
              id="agNM"
              name="agNM"
              type="text"
              class="form-control"
              maxlength="30"
              data-bind="Participant.Name"
              formControlName="aggregatorName"
              [ngClass]="{ 'is-invalid': submitted && formControls['aggregatorName'].errors }"
            />
          </div>
        </div>
      </div>
      <div class="row pd-10">
        <div class="col-sm-12">
          <div *ngIf="isAddNewConnection()">
            <button type="button" role="button" (click)="saveAsNewAPIConnectionProfile(true)" class="ba-btn ba-btn-vthin float-right ms-5">Save New</button>
          </div>
          <div *ngIf="!isAddNewConnection()" class="d-flex-reverse">
            <button type="button" role="button" (click)="saveAsNewAPIConnectionProfile(true)" class="ba-btn ba-btn-vthin float-right ms-1">Save as New</button>
            <button type="button" role="button" (click)="updateAPIConnectionProfile()" class="ba-btn ba-btn-vthin float-right ms-1">Update</button>
            <button type="button" role="button" (click)="deleteAPIConnectionProfile(true)" class="ba-btn ba-btn-vthin float-right ms-1">Delete</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
